import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import common from "translations/common.json";

const getLanguage = () => {
	if (navigator.language.includes("de")) {
		return "de";
	} else if (navigator.language.includes("en")) {
		return "en";
	} else {
		return "en";
	}
};

i18n.use(initReactI18next).init({
	interpolation: { escapeValue: false }, // React already does escaping
	lng: getLanguage(),
	fallbackLng: ["en", "de"], // language will be replaced in UserActions.js
	resources: common,
	ns: ["common"],
	defaultNS: "common",
});

export default i18n;
